var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, styled, Switch, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Config } from '../../../api/config';
import { ConfirmAppointmentURL } from '../../../api/url';
import { CrossIcon } from '../../../assets/images';
import { MuiBorderBottom, MuiStack } from '../../../components';
import { MuiIconButton } from '../../../components/atoms/iconButtonComponent';
import Loader from '../../../components/molecules/loader';
import { EModuleSection, EParentModuleName, ESectionAttributeValue, LOCAL_STORAGE_KEYS } from '../../../constants';
import { setJobCardTaskDetailsSummary } from '../../../redux/commonSlice';
import { getListAPI, updateAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import AdvisorSuggestions from '../../commonViews/taskDetails/taskDetailsCommonComponent/AdvisorSuggestions';
import FutureAdviseGrid from '../../futureAdvise/FutureAdviseGrid';
import CustomeAccordian from '../customAccordian';
import AdditionalJobs from './additionalJobs';
import PeriodicMaintainance from './periodicMaintainance';
import PreCheckTaskSummary from './preCheck';
import RoadTestList from './roadTest';
import StandaredJobs from './standaredJobs';
var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? bajajPrimaryBlue : bajajPrimaryBlue,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    };
});
var MyImg = styled("img")(function (_ref2) {
    var theme = _ref2.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var JCTaskSummary = function (props) {
    var _a = props.isHeaderShown, isHeaderShown = _a === void 0 ? true : _a, _b = props.isBackIcon, isBackIcon = _b === void 0 ? true : _b, _c = props.isCrossIcon, isCrossIcon = _c === void 0 ? true : _c, onCrossClick = props.onCrossClick, _d = props.isSaveButton, isSaveButton = _d === void 0 ? true : _d, jobCardId = props.jobCardId, jobCardData = props.jobCardData;
    var _e = useState(false), allswitchEnabled = _e[0], setAllSwitchEnabled = _e[1];
    var _f = React.useState(false), callApi = _f[0], setCallApi = _f[1];
    var _g = useState(false), addiotionalJobApiCall = _g[0], setAddiotionalJobApiCall = _g[1];
    var _h = useState(false), standardsJobApiCall = _h[0], setStandardsJobApiCall = _h[1];
    var _j = useState(false), precheckApiCall = _j[0], setPrecheckApiCall = _j[1];
    var _k = useState(false), roadTestApiCall = _k[0], setRoadTestApiCall = _k[1];
    var _l = useState(false), periodicMaintainanceApiCall = _l[0], setPeriodicMaintainanceApiCall = _l[1];
    var _m = useState(false), openPopup = _m[0], setOpenPopup = _m[1];
    var _o = useState(false), openAptcreatePopup = _o[0], setOpenAptcreatePopup = _o[1];
    var _p = useState({}), aptCode = _p[0], setAptcode = _p[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var jobCardTaskDetailsSummary = useSelector(function (state) { return state.common; }).jobCardTaskDetailsSummary;
    var id = useParams().id;
    var _q = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _q.documentDetailsGetById, savedSuggestions = _q.savedSuggestions, savedFutureAdvice = _q.savedFutureAdvice;
    var _r = useState({
        PERIODIC_MAINTENANCE: 0,
        ADDITIONAL_JOBS: 0,
        STANDARD_JOBS: 0,
        DECLINED_JOBS: 0,
        StaticChecklist: 0,
        DynamicQuestions: 0,
        FastnerQuestions: 0,
        CustomerVoiceToJobItem: 0,
        ROADTEST_JOBS: 0
    }), jobCardCounts = _r[0], setJobCardCounts = _r[1];
    useEffect(function () {
        getInitialData();
    }, []);
    useEffect(function () {
        if (documentDetailsGetById && documentDetailsGetById.data) {
            var _documentDetailsGetBy;
            getMasterTotalCount((_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.ProductId);
        }
        else if (jobCardData) {
            getMasterTotalCount(jobCardData.ProductId);
        }
    }, [documentDetailsGetById, jobCardData]);
    var getMasterTotalCount = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, jcId, body, response, _response$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("jobCardId", jobCardId);
                    console.log("id", id);
                    console.log("jobCardData", jobCardData);
                    jcId = id ? id : jobCardId;
                    body = {
                        JobCardId: jcId,
                        ProductId: productId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/FIMasterCount"),
                            request: body
                        }))];
                case 1:
                    response = _a.sent();
                    console.log("response >> > > >  >", response);
                    if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success) {
                        setJobCardCounts(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray;
        return __generator(this, function (_a) {
            try {
                if (jobCardTaskDetailsSummary.length == 0) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD);
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                        updatedList_1 = [];
                        data === null || data === void 0 || data.map(function (item) {
                            var newObj = Object.assign({}, item, item.Section);
                            delete newObj.Section;
                            updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                                isAccordianOpen: false
                            }));
                        });
                        obj_1 = {};
                        newArray_1 = [];
                        finalModuleSectionArray_1 = [];
                        res = updatedList_1.map(function (elem) {
                            var newSectionAttribute = elem.SectionAttributes;
                            var mergedObj = null;
                            var newAttribute = newSectionAttribute.map(function (el) {
                                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                    obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                    obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                    mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                                }
                            });
                            if (mergedObj) {
                                newArray_1.push(mergedObj);
                            }
                            obj_1 = {};
                            delete elem.SectionAttributes;
                            elem['SectionAttributes'] = [];
                            newArray_1.forEach(function (value) {
                                newSectionAttribute.forEach(function (value1) {
                                    if (value.id == value1.id) {
                                        elem.SectionAttributes.push(value);
                                    }
                                });
                            });
                            finalModuleSectionArray_1.push(elem);
                        });
                        sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        dispatch(setJobCardTaskDetailsSummary(sortedArray));
                    }
                }
            }
            catch (e) {
                console.log("Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    var onClickBackArrow = function () {
        setOpenPopup(true);
    };
    var handleAllSwitchButtonState = function () {
        setAllSwitchEnabled(!allswitchEnabled);
    };
    var getStandaredJobApiCall = function () {
        setStandardsJobApiCall(true);
    };
    var getAdditionalJobApiCall = function () {
        setAddiotionalJobApiCall(true);
    };
    var onClickNoBtn = function () {
        setOpenPopup(false);
        // navigate('/inspection')
    };
    var goToHomePage = function () {
        navigate('/appointment');
    };
    var onClickYesBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                navigate("/serviceEstimate-details/".concat(props.parentModuleDocumentId));
            }
            if (props.parentModuleName === EParentModuleName.Appointment) {
                navigate("/appointment-Detail/".concat(props.parentModuleDocumentId));
            }
            return [2 /*return*/];
        });
    }); };
    var ConfirmAppointment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _props$parentModuleDo, _result$payload, _result$payload2, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(updateAPI({
                        key: "",
                        url: ConfirmAppointmentURL((_props$parentModuleDo = props.parentModuleDocumentId) !== null && _props$parentModuleDo !== void 0 ? _props$parentModuleDo : '')
                    }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                        setAptcode(result.payload.data);
                        // dispatch(showNotification({ isOpen: true, message: "Save successfully", type: "success" }))
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickGenerateEstimate = function () {
        if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
            navigate("/serviceEstimate-details/".concat(props.parentModuleDocumentId));
        }
        if (props.parentModuleName === EParentModuleName.Appointment) {
            ConfirmAppointment();
            setOpenAptcreatePopup(true);
        }
    };
    var handleCancelPopup = function () {
        navigate('/appointment');
    };
    var handleAccordianClick = function (value, key) {
        var updatedList = jobCardTaskDetailsSummary === null || jobCardTaskDetailsSummary === void 0 ? void 0 : jobCardTaskDetailsSummary.map(function (item) { return item.Key == key ? _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: value
        }) : _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: false
        }); });
        dispatch(setJobCardTaskDetailsSummary(updatedList));
    };
    var padding = isHeaderShown ? "16px 16px 8px 16px" : "4px";
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, isHeaderShown && /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        spacing: 1,
        paddingY: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '92%',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        sx: {
            marginLeft: isCrossIcon ? 2 : 0
        }
    }, t("Task summary")), isCrossIcon && /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "BackArrowClick",
        onClick: onCrossClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: CrossIcon,
        alt: "close"
    })))), /*#__PURE__*/ React.createElement(Loader, null), isHeaderShown && /*#__PURE__*/ React.createElement(MuiBorderBottom, null), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, (jobCardTaskDetailsSummary === null || jobCardTaskDetailsSummary === void 0 ? void 0 : jobCardTaskDetailsSummary.length) > 0 ? jobCardTaskDetailsSummary === null || jobCardTaskDetailsSummary === void 0 ? void 0 : jobCardTaskDetailsSummary.map(function (item) {
        var _item$SectionAttribut, _item$SectionAttribut2, _item$SectionAttribut3, _item$SectionAttribut4, _item$SectionAttribut5, _item$SectionAttribut6, _item$SectionAttribut7, _item$SectionAttribut8, _item$SectionAttribut9, _item$SectionAttribut10, _item$SectionAttribut11, _item$SectionAttribut12, _item$SectionAttribut13, _item$SectionAttribut14, _item$SectionAttribut15, _item$SectionAttribut16, _item$SectionAttribut17, _item$SectionAttribut18, _item$SectionAttribut19, _item$SectionAttribut20, _item$SectionAttribut21;
        return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance && (item === null || item === void 0 || (_item$SectionAttribut = item.SectionAttributes) === null || _item$SectionAttribut === void 0 ? void 0 : _item$SectionAttribut.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut2 = item.SectionAttributes[0]) !== null && _item$SectionAttribut2 !== void 0 && _item$SectionAttribut2.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut3 = item.SectionAttributes) === null || _item$SectionAttribut3 === void 0 ? void 0 : _item$SectionAttribut3.map(function (elem) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    setPeriodicMaintainanceApiCall(true);
                },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.PeriodicMaintenance); },
                countVisible: true,
                listLength: jobCardCounts === null || jobCardCounts === void 0 ? void 0 : jobCardCounts.PERIODIC_MAINTENANCE
            }, /*#__PURE__*/ React.createElement(PeriodicMaintainance, {
                id: jobCardId,
                callApIStatus: periodicMaintainanceApiCall
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.StandardJobs && (item === null || item === void 0 || (_item$SectionAttribut4 = item.SectionAttributes) === null || _item$SectionAttribut4 === void 0 ? void 0 : _item$SectionAttribut4.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut5 = item.SectionAttributes[0]) !== null && _item$SectionAttribut5 !== void 0 && _item$SectionAttribut5.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut6 = item.SectionAttributes) === null || _item$SectionAttribut6 === void 0 ? void 0 : _item$SectionAttribut6.map(function (elem) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return getStandaredJobApiCall(); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.StandardJobs); },
                countVisible: true,
                listLength: jobCardCounts === null || jobCardCounts === void 0 ? void 0 : jobCardCounts.STANDARD_JOBS
            }, /*#__PURE__*/ React.createElement(StandaredJobs, {
                id: jobCardId,
                callApIStatus: standardsJobApiCall
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.Precheck && (item === null || item === void 0 || (_item$SectionAttribut7 = item.SectionAttributes) === null || _item$SectionAttribut7 === void 0 ? void 0 : _item$SectionAttribut7.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut8 = item.SectionAttributes[0]) !== null && _item$SectionAttribut8 !== void 0 && _item$SectionAttribut8.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut9 = item.SectionAttributes) === null || _item$SectionAttribut9 === void 0 ? void 0 : _item$SectionAttribut9.map(function (elem) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return setPrecheckApiCall(true); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.Precheck); }
            }, /*#__PURE__*/ React.createElement(PreCheckTaskSummary, {
                id: jobCardId,
                jobCardData: jobCardData,
                callApIStatus: precheckApiCall
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTest && (item === null || item === void 0 || (_item$SectionAttribut10 = item.SectionAttributes) === null || _item$SectionAttribut10 === void 0 ? void 0 : _item$SectionAttribut10.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut11 = item.SectionAttributes[0]) !== null && _item$SectionAttribut11 !== void 0 && _item$SectionAttribut11.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut12 = item.SectionAttributes) === null || _item$SectionAttribut12 === void 0 ? void 0 : _item$SectionAttribut12.map(function (elem) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return setRoadTestApiCall(true); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.RoadTest); },
                countVisible: true,
                listLength: jobCardCounts === null || jobCardCounts === void 0 ? void 0 : jobCardCounts.ROADTEST_JOBS
            }, /*#__PURE__*/ React.createElement(RoadTestList, {
                id: jobCardId,
                callApIStatus: roadTestApiCall
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdditionalJobs && (item === null || item === void 0 || (_item$SectionAttribut13 = item.SectionAttributes) === null || _item$SectionAttribut13 === void 0 ? void 0 : _item$SectionAttribut13.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut14 = item.SectionAttributes[0]) !== null && _item$SectionAttribut14 !== void 0 && _item$SectionAttribut14.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut15 = item.SectionAttributes) === null || _item$SectionAttribut15 === void 0 ? void 0 : _item$SectionAttribut15.map(function (elem) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return getAdditionalJobApiCall(); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.AdditionalJobs); },
                countVisible: true,
                listLength: jobCardCounts === null || jobCardCounts === void 0 ? void 0 : jobCardCounts.ADDITIONAL_JOBS
            }, /*#__PURE__*/ React.createElement(AdditionalJobs, {
                id: jobCardId,
                callApIStatus: addiotionalJobApiCall
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdvisorSuggestions && (item === null || item === void 0 || (_item$SectionAttribut16 = item.SectionAttributes) === null || _item$SectionAttribut16 === void 0 ? void 0 : _item$SectionAttribut16.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut17 = item.SectionAttributes[0]) !== null && _item$SectionAttribut17 !== void 0 && _item$SectionAttribut17.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut18 = item.SectionAttributes) === null || _item$SectionAttribut18 === void 0 ? void 0 : _item$SectionAttribut18.map(function (elem) {
            var _savedSuggestions$dat, _documentDetailsGetBy2;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return getAdditionalJobApiCall(); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.AdvisorSuggestions); },
                countVisible: true,
                listLength: (savedSuggestions === null || savedSuggestions === void 0 || (_savedSuggestions$dat = savedSuggestions.data) === null || _savedSuggestions$dat === void 0 ? void 0 : _savedSuggestions$dat.length) || 0
            }, /*#__PURE__*/ React.createElement(AdvisorSuggestions, {
                installBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.InstallBaseId,
                documentId: id,
                documentType: 'JobCard',
                isDisabled: true
                // onSave={(updatedSuggestions) => setSuggestions(updatedSuggestions)}
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.FutureAdvise && (item === null || item === void 0 || (_item$SectionAttribut19 = item.SectionAttributes) === null || _item$SectionAttribut19 === void 0 ? void 0 : _item$SectionAttribut19.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut20 = item.SectionAttributes[0]) !== null && _item$SectionAttribut20 !== void 0 && _item$SectionAttribut20.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: padding
        }, item === null || item === void 0 || (_item$SectionAttribut21 = item.SectionAttributes) === null || _item$SectionAttribut21 === void 0 ? void 0 : _item$SectionAttribut21.map(function (elem) {
            var _savedFutureAdvice$da;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordian, {
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_SUMMARY_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { return getAdditionalJobApiCall(); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.FutureAdvise); },
                countVisible: true,
                listLength: (savedFutureAdvice === null || savedFutureAdvice === void 0 || (_savedFutureAdvice$da = savedFutureAdvice.data) === null || _savedFutureAdvice$da === void 0 ? void 0 : _savedFutureAdvice$da.length) || 0
            }, /*#__PURE__*/ React.createElement(FutureAdviseGrid, {
                documentId: id,
                documentType: 'JobCard',
                isDisabled: true,
                documentData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data
            })) : null;
        })) : null;
    }) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        paddingTop: 25,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("No Data Found"), "..!!"))))));
};
export default JCTaskSummary;
